import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkBoldCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 4C11.163 4 4 11.163 4 20s7.163 16 16 16 16-7.163 16-16S28.837 4 20 4Zm0 3.097c7.131 0 12.903 5.77 12.903 12.903 0 7.131-5.77 12.903-12.903 12.903-7.131 0-12.903-5.77-12.903-12.903 0-7.131 5.77-12.903 12.903-12.903Zm9.045 8.404-1.454-1.466a.774.774 0 0 0-1.094-.004l-9.12 9.046-3.857-3.889a.774.774 0 0 0-1.095-.004l-1.466 1.454a.774.774 0 0 0-.004 1.095l5.856 5.904a.774.774 0 0 0 1.095.004l11.135-11.045a.774.774 0 0 0 .004-1.095Z" })
});
export default SvgCheckmarkBoldCircle;
